import { combineReducers } from 'redux'
import {
  CHANGE_CURRENT_STEP_START,
  CHANGE_CURRENT_STEP_FINISH,
  CHANGE_CURRENT_STEP_CANCEL,
  UPDATE_ORDER_DATA,
  UPDATE_PRODUCT_DATA,
  UPDATE_PRODUCT_SCHEDULE_SLOTS_DATA,
  FETCH_ORDER_DATA_START,
  FETCH_ORDER_DATA_SUCCESS,
  FETCH_ORDER_DATA_FAILURE,
  LOAD_PRODUCT_DATA_START,
  LOAD_PRODUCT_DATA_SUCCESS,
  LOAD_PRODUCT_DATA_FAILURE,
  LOAD_PRODUCT_SCHEDULE_SLOT_DATA,
  LOAD_PRODUCT_SCHEDULE_SLOTS_DATA_START,
  LOAD_PRODUCT_SCHEDULE_SLOTS_DATA_SUCCESS,
  LOAD_PRODUCT_SCHEDULE_SLOTS_DATA_FAILURE,
  UPDATE_PRODUCT_SCHEDULE_SLOT,
  ABANDON_ORDER_START,
  ABANDON_ORDER_SUCCESS,
  ABANDON_ORDER_FAILURE,
  SAVE_ORDER_START,
  SAVE_ORDER_SUCCESS,
  SAVE_ORDER_FAILURE,
  CONFIRM_ORDER_START,
  CONFIRM_ORDER_SUCCESS,
  CONFIRM_ORDER_FAILURE,
  CALCULATE_ORDER_START,
  CALCULATE_ORDER_SUCCESS,
  CALCULATE_ORDER_FAILURE,
  CHANGE_PAYMENT_GATEWAY,
  PAYMENT_FORM_SUBMIT_START,
  PAYMENT_FORM_SUBMIT_SUCCESS,
  PAYMENT_FORM_SUBMIT_FAILURE,
  PAYMENT_FORM_UPDATE_PAYMENT_OPERATION,
  SELECT_PRODUCT_SCHEDULE_SLOT,
  SET_VALIDATION_ERRORS,
  APPROVE_ORDER,
  APPROVE_ORDER_START,
  APPROVE_ORDER_SUCCESS,
  APPROVE_ORDER_FAILURE,
  REJECT_ORDER,
  REJECT_ORDER_START,
  REJECT_ORDER_SUCCESS,
  REJECT_ORDER_FAILURE,
  SET_IS_SMALL_VIEW,
  TRIGGER_WINDOW_RESIZE,
  INITIALIZE_MAIN_VIEW_FINISH,
} from '../actions'
import isConfirmPricingStepEnabledSelector from '../selectors/isConfirmPricingStepEnabledSelector'

const initialState = {
  orderData: {},
  productData: null,
  errors: {},
  fetchOrderLoading: true,
  fetchOrderDone: false,
  fetchOrderFailed: false,
  fetchProductVariantsLoading: true,
  fetchProductVariantsrDone: false,
  fetchProductVariantsFailed: false,
  product_schedule_slots: [],
  productScheduleSlotsLoading: true,
  loadingStep: null,
  currentStep: null,
  window: undefined,
  paymentFormData: {
    payment_operation: null,
    isLoading: false,
    gateway: null,
  },
  isApproveOrderLoading: false,
  hasApproveOrderFailed: false,
  initializeViewLoading: true,
}

const app = (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_MAIN_VIEW_FINISH:
      return {
        ...state,
        initializeViewLoading: false
      }

    case CHANGE_CURRENT_STEP_START:
      return {
        ...state,
        loadingStep: action.step
      }

    case CHANGE_CURRENT_STEP_FINISH:
      return {
        ...state,
        loadingStep: null,
        currentStep: action.step
      }

    case CHANGE_CURRENT_STEP_CANCEL:
      return {
        ...state,
        loadingStep: null
      }

    case UPDATE_ORDER_DATA:
      return {
        ...state,
        orderData: {...state.orderData, ...action.data}
      }

    case UPDATE_PRODUCT_DATA:
      return {
        ...state,
        productData: action.data
      }

    case UPDATE_PRODUCT_SCHEDULE_SLOTS_DATA:
      return {
        ...state,
        lastSlotSelectDate: action.data.lastSlotSelectDate,
        product_schedule_slots: state.product_schedule_slots.concat(action.data.slots),
        productScheduleSlotsLoading: false,
      }

    case LOAD_PRODUCT_SCHEDULE_SLOT_DATA:
      return {
        ...state,
        orderData: {
          ...state.orderData,
          product_schedule_slot: action.data.slot
        }
      }

    case FETCH_ORDER_DATA_START:
    case LOAD_PRODUCT_DATA_START:
      return {
        ...state,
        // fetchOrderLoading: true,
        // fetchOrderDone: false,
        fetchOrderFailed: false,
      }

    case FETCH_ORDER_DATA_SUCCESS:
    case LOAD_PRODUCT_DATA_SUCCESS:
      return {
        ...state,
        fetchOrderLoading: false,
        fetchOrderDone: true,
      }

    case FETCH_ORDER_DATA_FAILURE:
    case LOAD_PRODUCT_DATA_FAILURE:
      return {
        ...state,
        fetchOrderLoading: false,
        fetchOrderDone: false,
        fetchOrderFailed: true,
      }

    case LOAD_PRODUCT_SCHEDULE_SLOTS_DATA_START:
      return {
        ...state,
        // fetchOrderLoading: true,
        // fetchOrderDone: false,
        fetchProductVariantsFailed: false,
        productScheduleSlotsLoading: true,
      }

    case LOAD_PRODUCT_SCHEDULE_SLOTS_DATA_SUCCESS:
      return {
        ...state,
        fetchProductVariantsLoading: false,
        fetchProductVariantsDone: true,
      }

    case LOAD_PRODUCT_SCHEDULE_SLOTS_DATA_FAILURE:
      return {
        ...state,
        fetchProductVariantsLoading: false,
        fetchProductVariantsDone: false,
        fetchProductVariantsFailed: true,
      }

    case UPDATE_PRODUCT_SCHEDULE_SLOT:
      return {
        ...state,
        orderData: {
          ...state.orderData,
          product_schedule_slot: state.product_schedule_slots
            .filter((slot) => {
              return slot.id == state.orderData.product_schedule_slot_id
            })[0]
        }
      }

    case ABANDON_ORDER_START:
      return {
        ...state,
        isAbandonOrderLoading: true
      }

    case ABANDON_ORDER_SUCCESS:
      return {
        ...state,
        orderData: {
          ...state.orderData,
          id: undefined,
          token: undefined,
          status: undefined,
          ordered_product_order_fields: (state.orderData.ordered_product_order_fields || [])
            .map(orderedField => { return {
              ...orderedField,
              id: undefined
            }}),
          ordered_product_pricelist_items: (state.orderData.ordered_product_pricelist_items || [])
            .map(orderedItem => { return {
              ...orderedItem,
              id: undefined,
              ordered_product_order_fields: orderedItem.ordered_product_order_fields
                .map(orderedField => { return {
                  ...orderedField,
                  id: undefined
                }}),
            }}),
          order_customer_participants: (state.orderData.order_customer_participants || [])
            .map(participant => { return {
              ...participant,
              id: undefined,
              ordered_product_order_fields: participant.ordered_product_order_fields
                .map(orderedField => { return {
                  ...orderedField,
                  id: undefined
                }}),
            }})
        },
        isAbandonOrderLoading: false
      }

    case ABANDON_ORDER_FAILURE:
      return {
        ...state,
        isAbandonOrderLoading: false
      }

    case APPROVE_ORDER_START:
    case REJECT_ORDER_START:
      return {
        ...state,
        isApproveOrderLoading: true,
        hasApproveOrderFailed: false,
      }

    case APPROVE_ORDER_SUCCESS:
    case REJECT_ORDER_SUCCESS:
      return {
        ...state,
        isApproveOrderLoading: false,
        hasApproveOrderFailed: false,
      }

    case APPROVE_ORDER_FAILURE:
    case REJECT_ORDER_FAILURE:
      return {
        ...state,
        isApproveOrderLoading: false,
        hasApproveOrderFailed: true,
      }

    case SAVE_ORDER_START:
    case CONFIRM_ORDER_START:
      return {
        ...state,
        errors: {},
        isSaveOrderLoading: true
      }

    case SAVE_ORDER_SUCCESS:
    case CONFIRM_ORDER_SUCCESS:
      return {
        ...state,
        errors: {},
        isSaveOrderLoading: false
      }

    case SAVE_ORDER_FAILURE:
    case CONFIRM_ORDER_FAILURE:
      return {
        ...state,
        isSaveOrderLoading: false
      }

    case CALCULATE_ORDER_START:
      return {
        ...state,
        isCalculateOrderLoading: true
      }

    case CALCULATE_ORDER_SUCCESS:
      return {
        ...state,
        errors: {},
        isCalculateOrderLoading: false
      }

    case CALCULATE_ORDER_FAILURE:
      return {
        ...state,
        isCalculateOrderLoading: false
      }

    case CHANGE_PAYMENT_GATEWAY:
      return {
        ...state,
        paymentFormData: {
          ...state.paymentFormData,
          gateway: action.gateway,
        }
      }

    case PAYMENT_FORM_SUBMIT_START:
      return {
        ...state,
        paymentFormData: {
          ...state.paymentFormData,
          isLoading: true
        }
      }

    case PAYMENT_FORM_SUBMIT_SUCCESS:
      return {
        ...state,
        paymentFormData: {
          ...state.paymentFormData,
          isLoading: false
        }
      }

    case PAYMENT_FORM_SUBMIT_FAILURE:
      return {
        ...state,
        paymentFormData: {
          ...state.paymentFormData,
          isLoading: false
        }
      }

    case PAYMENT_FORM_UPDATE_PAYMENT_OPERATION:
      return {
        ...state,
        paymentFormData: {
          ...state.paymentFormData,
          payment_operation: action.payment_operation
        }
      }

    case SELECT_PRODUCT_SCHEDULE_SLOT:
      return {
        ...state,
        orderData: {
          ...state.orderData,
          product_variant_id: action.slot.product_variant_id,// ? action.slot.product_variant_id : undefined,
          product_schedule_slot: action.slot,//? action.slot.id : undefined
          product_schedule_slot_id: action.slot.id,
        }
      }

    case SET_VALIDATION_ERRORS:
      return {
        ...state,
        errors: action.errors
      }

    case SET_IS_SMALL_VIEW:
      return {
        ...state,
        isWidgetView: action.data
      }

    case TRIGGER_WINDOW_RESIZE:
      return {
        ...state,
        window: action.data
      }

    default:
      return state;
  }
}

export default app



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/reducers/index.js